<template>
  <div class="wrapper wrapper-content p-0 animated fadeInUp">
    <div class="ibox-body">
      <!-- Header with add icon -->
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ $t("navigations.schedule of assessments list") }}</h5>
         <div class="position-relative align-self-center">
        <img src="@/assets/img/create.png" width="17" alt="Add Schedule of Assessment" style="cursor: pointer;"
          @click="addNewRow" />
        <div class="tool-tip mt-2">Add Schedule of Assessment</div>
      </div>
      </div>
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Visit Number <sup><i class="fa fa-asterisk required"></i></sup></th>
                <th>Activity ID <sup><i class="fa fa-asterisk required"></i></sup></th>
                <th>Activity Order</th>
                <th>Activity Name</th>
                <th>Activity Type</th>
                <th>Is Required?</th>
                <th>SoA ID</th>
                <th class="text-center sticky-column">Edit</th>
                <th class="text-center">Delete</th>
              </tr>
            </thead>
            <tbody>
              <!-- New Row for creation -->
              <tr v-if="isAddingNew">
                <td>
                  <input v-model="newRow.visitNumber" class="form-control" type="text" @input="clearNewFieldError('visitNumber')" />
                  <div v-if="newRowErrors.visitNumber" class="text-danger">{{ newRowErrors.visitNumber }}</div>
                </td>
                <td>
                  <input v-model="newRow.activityId" class="form-control" type="text" @input="clearNewFieldError('activityId')" />
                  <div v-if="newRowErrors.activityId" class="text-danger">{{ newRowErrors.activityId }}</div>
                </td>
                <td>
                  <input v-model.number="newRow.activityOrder" class="form-control" type="number" />
                </td>
                <td>
                  <input v-model="newRow.activityName" class="form-control" type="text" />
                </td>
                <td>
                  <input v-model="newRow.activityType" class="form-control" type="text" />
                </td>
                <td>
                  <select class="form-select" v-model="newRow.isRequired">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </td>
                <td>
                  <input v-model="newRow.soaId" class="form-control" type="text" />
                </td>
                <td class="text-center sticky-column">
                  <i class="fa fa-check action-icon text-success" @click="saveNewRow" title="Save"></i>
                  <i class="fa fa-times action-icon text-danger" @click="cancelNewRow" title="Cancel"></i>
                </td>
                <td></td>
              </tr>

              <!-- No data row -->
              <tr v-if="!isAddingNew && scheduleOfAssessments.length === 0">
                <td colspan="9" class="text-center">No data available.</td>
              </tr>

              <!-- Existing rows -->
              <tr v-for="(soa, index) in scheduleOfAssessments" :key="soa.id">
                <!-- Visit Number -->
                <td v-if="editIndex !== index">{{ soa.visitNumber }}</td>
                <td v-else>
                  <input v-model="editableRow.visitNumber" class="form-control" type="text" @input="clearFieldError('visitNumber')" />
                  <div v-if="validationErrors.visitNumber" class="text-danger">{{ validationErrors.visitNumber }}</div>
                </td>
                <!-- Activity ID -->
                <td v-if="editIndex !== index">{{ soa.activityId }}</td>
                <td v-else>
                  <input v-model="editableRow.activityId" class="form-control" type="text" @input="clearFieldError('activityId')" />
                  <div v-if="validationErrors.activityId" class="text-danger">{{ validationErrors.activityId }}</div>
                </td>
                <!-- Activity Order -->
                <td v-if="editIndex !== index">{{ soa.activityOrder }}</td>
                <td v-else>
                  <input v-model.number="editableRow.activityOrder" class="form-control" type="number" />
                </td>
                <!-- Activity Name -->
                <td v-if="editIndex !== index">{{ soa.activityName }}</td>
                <td v-else>
                  <input v-model="editableRow.activityName" class="form-control" type="text" />
                </td>
                <!-- Activity Type -->
                <td v-if="editIndex !== index">{{ soa.activityType }}</td>
                <td v-else>
                  <input v-model="editableRow.activityType" class="form-control" type="text" />
                </td>
                <!-- Is Required? -->
                <td v-if="editIndex !== index">{{ soa.isRequired ? "Yes" : "No" }}</td>
                <td v-else>
                  <select class="form-select" v-model="editableRow.isRequired">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </td>
                <!-- SoA ID -->
                <td v-if="editIndex !== index">{{ soa.soAId }}</td>
                <td v-else>
                  <input v-model="editableRow.soAId" class="form-control" type="text" />
                </td>
                <!-- Edit Actions -->
                <td class="text-center sticky-column">
                  <template v-if="editIndex !== index">
                    <i class="fa fa-edit edit-delete" v-if="protocol.status !== 'Generated'"
                      @click.prevent="editRow(index, soa)"></i>
                  </template>
                  <template v-else>
                    <i class="fa fa-check action-icon text-success" @click="updateRow(soa.id)" title="Update"></i>
                    <i class="fa fa-times action-icon text-danger" @click="cancelEdit" title="Cancel"></i>
                  </template>
                </td>
                <!-- Delete -->
                <td class="text-center">
                  <i class="fa fa-trash edit-delete" v-if="protocol.status !== 'Generated'" style="color: #a13b7c"
                    @click="deleteRow(soa.id)"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mx-0" v-if="scheduleOfAssessments.length > 0">
          <div class="col-lg-12 mx-0 px-0">
            <div class="dataTables_paginate paging_simple_numbers pagination float-right">
              <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                <v-pagination v-model="currentPage" :pages="totalPages" :range-size="0" active-color="#618bd7"
                  @update:modelValue="loadPage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.action-icon {
  cursor: pointer;
  font-size: 18px;
  margin: 0 5px;
}

.action-icon:hover {
  opacity: 0.8;
}

.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}

.wrap-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 200px;
  overflow: hidden;
}

textarea.form-control {
  resize: vertical;
  max-height: 150px;
}

.sticky-column {
  position: sticky;
  right: 0;
  background-color: #fff;
  z-index: 10;
  border-left: 1px solid #dee2e6;
}

.badge-success {
  background-color: #28a745;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
}

.badge-secondary {
  background-color: #6c757d;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
}
.position-relative .tool-tip {  
  right: 20px;
  top: 0px;
}
</style>

<script src="./Scheduleofassessmentmanagement.js"></script>